import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import {
  getSmartHeatPumpUsageOverview,
  getSmartHeatPumpUsageDetails,
  getDeviceTelemetry,
  updateDeviceRoomTemperature,
  updateDeviceControlMode,
  updateOptimizationSettings,
} from '../services/SmartHeatPumpService';

export const useSmartHeatPumpGetSmartHeatPumpUsageOverview = createDCHook(
  'getSmartHeatPumpUsageOverview',
  collapseDataFromCall(getSmartHeatPumpUsageOverview),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
);

export const useSmartHeatPumpGetSmartHeatPumpUsageDetails = createDCHook(
  'getSmartHeatPumpUsageDetails',
  collapseDataFromCall(getSmartHeatPumpUsageDetails),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
);

export const useSmartHeatPumpGetDeviceTelemetry = createDCHook(
  'getDeviceTelemetry',
  collapseDataFromCall(getDeviceTelemetry),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
);

export const useSmartHeatPumpUpdateDeviceRoomTemperature = createMutationHook(updateDeviceRoomTemperature, {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: false,
});

export const useSmartHeatPumpUpdateDeviceControlMode = createMutationHook(updateDeviceControlMode, {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: false,
});

export const useSmartHeatPumpUpdateOptimizationSettings = createMutationHook(
  collapseParams(collapseParams(updateOptimizationSettings, 'requestBody', 'data'), 'data', 'setting', 'enabled'),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['setting', 'enabled'] },
    ],
  },
);
